// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__zJnwz","slides":"Slider_slides__Y4lto"};